import {
  Document,
  ScreenerDocumentError,
  ScreenerDocumentErrorErrorTypeEnum,
  ScreenerDocumentErrorMetadata,
  ScreenerDocumentErrorMetadataRelatedDocumentInformationInner
} from '@/types/crm-screener';

export class DocumentErrorModel implements ScreenerDocumentError {
  id: string;
  lead_id: string;
  document_id?: string | undefined;

  error_type: ScreenerDocumentErrorErrorTypeEnum;
  metadata?: ScreenerDocumentErrorMetadata | undefined;

  dismissed_at?: Date | undefined;
  recovered_at?: string | undefined;

  created_at?: Date | undefined;
  updated_at?: Date | undefined;
  deleted_at?: Date | undefined;

  constructor(payload: ScreenerDocumentError) {
    Object.assign(this, payload);
  }

  getDocumentData(): Pick<Document, 'name' | 'page_count' | 'filesize'> {
    return {
      name: this.metadata?.related_document_information?.[0]?.name ?? '',
      page_count: this.metadata?.related_document_information?.[0]?.pages,
      filesize: this.metadata?.related_document_information?.[0]?.size
    };
  }
}
